import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  CloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { HIDE_ANNOUNCEMENT_KEY } from "../../constants";
import useSettingsStore from "../../store/settings";

const AnnouncementBanner = () => {
  const [settings] = useSettingsStore(state => [state.settings]);
  const { isOpen: isVisible, onClose: closeAlert } = useDisclosure({ defaultIsOpen: true });
  const announcementText = settings?.announcement_text;

  if (localStorage.getItem(HIDE_ANNOUNCEMENT_KEY)) {
    return null;
  }

  const onClose = () => {
    localStorage.setItem(HIDE_ANNOUNCEMENT_KEY, "true");
    closeAlert();
  };

  return isVisible ? (
    <Box p={4} pb={0} pt={2}>
      <Alert status="info" position="relative">
        <AlertIcon />
        <Box pr={3}>
          <AlertDescription>{announcementText}</AlertDescription>
        </Box>
        <CloseButton position="absolute" right="4px" top="8px" onClick={onClose} />
      </Alert>
    </Box>
  ) : null;
};

export default AnnouncementBanner;
